module.exports = __webpack_public_path__ + "img/wheel_HIGH_win.45c528ae.png";